import React, { act } from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import {
  userIsLogged,
  getRoute,
  apiDeleteConFile,
  apiGetAllAgent,
  apiSaveAvpNodoAgent,
  apiDeleteApvAgent,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { getValueByQueryString } from "../shared/manager/util";
import GestioneContenutiTree from "./GestioneContenutiTree";
import { useGraphStore } from "../new-avp/test-graph/store";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneAgentListScreen() {
  let actionQuery = getValueByQueryString("action");
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const { selectedNode, selectedLingua, avp } = useGraphStore((state) => state);

  const { selectedLinguaTesto } = useLingueStore((state) => state);
  const breadCrumb = [
    { title: selectedLinguaTesto?.GestioneAgentListBreadcrumb1, link: null },
  ];

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  function startPage() {
    console.log("startPage");
    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 30)) {
        navigate("/");
      }
      initPage();
    }
  }

  function stopPage() {
    console.log("stopPage");
  }

  function initPage() {
    console.log("initPage");

    apiGetAllAgent(function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setRows(response.data);
      }
    });
    //fai la get all agents
  }

  function handleOnAdd(idAgent) {
    apiSaveAvpNodoAgent(
      selectedNode.idNodo,
      selectedLingua.idLingua,
      idAgent,
      function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          navigate(
            "/avp/grafo/" +
              avp.idAvp +
              "?idnodo=" +
              selectedNode.idNodo +
              "&idlingua=" +
              selectedLingua.idLingua
          );
          //console.log("playlistFiles:", response.data);
        }
      }
    );
  }

  const columns = [
    {
      field: "descrizione",
      headerName: selectedLinguaTesto?.GestioneAgentListColumnDesc,
      flex: 2,
      sortable: true,
      headerClassName: "tableHeader",
    },
    {
      field: "status",
      headerName: selectedLinguaTesto?.GestioneAgentListColumnStatus,
      flex: 2,
      sortable: true,
      headerClassName: "tableHeader",
      renderCell: (params) => {
        return (
          <div>
            {params.row.status == "done"
              ? selectedLinguaTesto?.GestioneAgentListStatusDone
              : params.row.status == "error"
              ? selectedLinguaTesto?.GestioneAgentListStatusError
              : selectedLinguaTesto?.GestioneAgentListStatusLoading}
          </div>
        );
      },
    },

    // {
    //   field: 'tipoContenuto', headerName: 'Tipo', flex: 1, sortable: true, headerClassName: 'tableHeader',
    //   renderCell: (params) => {
    //     let desc = getTipoFileDesc(params.row.tipoContenuto);

    //     return desc;
    //   }
    // },
    // { field: 'pathFile', headerName: 'File', flex: 1, sortable: true, headerClassName: 'tableHeader' },
    // { field: 'folderPath', headerName: 'Cartella', flex: 1, sortable: true, headerClassName: 'tableHeader' },
    {
      field: "action",
      headerName: "",
      width: 160,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking
          const action = event.target.dataset.action;

          if (action == "edit") {
            handleEdit(params.row.agentId);
            // navigate(`/contenuti/agent?id=${params.row.agentId}`);
          }
          if (action == "add") {
            handleOnAdd(params.row.agentId);

            //chiamata di aggiunta
          }
          if (action == "delete") {
            handleDelete(params.row.agentId);
            // (params.row.idFile);
          }
        };

        let showUp = params.row.ordine > 1;
        let showDown = params.row.ordine == 1;

        return (
          <div className="tableActionSmallButton">
            {/* <img
              data-action="preview"
              src="/images/preview_btn.svg"
              title="anteprima"
              onClick={onClick}
            /> */}
            {params.row.status == "done" && (
              <img
                data-action="edit"
                src="/images/edit_btn.svg"
                title={selectedLinguaTesto?.GestioneAgentListImgEdit}
                onClick={onClick}
              />
            )}
            <img
              data-action="delete"
              src="/images/delete_btn.svg"
              title={selectedLinguaTesto?.GestioneAgentListImgDelete}
              onClick={onClick}
            />
            {params.row.status == "done" && actionQuery == "addtonode" && (
              <img
                data-action="add"
                src="/images/add_node_btn.svg"
                title={selectedLinguaTesto?.GestioneAgentListImgAdd}
                onClick={onClick}
              />
            )}
          </div>
        );
      },
    },
  ];

  function findFileInRows(idFile) {
    if (rows != null && rows.length > 0) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].idFile == idFile) {
          return rows[i];
        }
      }
    }
    return null;
  }

  function handleNew() {
    const dest =
      "/contenuti/agent?id=" + //idAgent
      navigate(dest);
  }

  function handleEdit(idAgent) {
    const dest = "/contenuti/agent?id=" + idAgent; //idAgent
    navigate(dest);
  }

  function handlePreview(idFile) {
    let file = findFileInRows(idFile);
    if (file != null && file.urlFile != null) {
      window.open(file.urlFile, "_blank");
    }
  }

  function handleDelete(idAgent) {
    apiDeleteApvAgent(idAgent, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
    // setDeleteDialogOpen(true);
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    setDeleteDialogOpen(false);
    apiDeleteConFile(idToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  function handleNew() {
    navigate("/contenuti/agent?action=new");
  }

  return (
    <div id="avp-gestionecontenuti-screen">
      <AvpHeader selectedMenuId={"contenuti"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#contenuti"} />
      <div id="avp-cms-screen-container" className="clearfix">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAgentListAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneAgentListAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-screen-title">
          {selectedLinguaTesto?.GestioneAgentListPageTitle}
        </div>
        <div className="avp-cms-screen-content clearfix">
          <div className="avp-cms-screen-toolbar clearfix">
            <div
              className="avp-cms-screen-toolbar-add"
              onClick={handleNew}
              style={{ marginLeft: "20px" }}
            >
              <button>{selectedLinguaTesto?.GestioneAgentListButtonNew}</button>
            </div>
          </div>

          <div id="avp-cms-contenuti-screen-box" className="clearfix">
            <div
              id="avp-cms-contenuti-screen-box-list"
              style={{ position: "relative", float: "left", width: "70%" }}
            >
              <Box sx={{ width: "100%" }}>
                <DataGrid
                  disableColumnMenu
                  getRowId={(row) => row.agentId}
                  rows={rows}
                  columns={columns}
                  getRowClassName={(params) => "tableRow"}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 10,
                      },
                    },
                  }}
                  pageSizeOptions={[10, 20, 30, 40]}
                  disableRowSelectionOnClick
                  autoheight
                />
              </Box>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Conferma eliminazione"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.GestioneAgentListDialogTitle}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>
            {selectedLinguaTesto?.GestioneAgentListDialogUndo}
          </Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneAgentListDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
